export default __webpack_public_path__ + "static/thumbnail3-c66d41a07e5da2da4112cedf53fd721a.jpg";